/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Green_Rat_GazeInputs */

const en_lean_green_rat_gaze = /** @type {(inputs: Lean_Green_Rat_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More add options`)
};

const de_lean_green_rat_gaze = /** @type {(inputs: Lean_Green_Rat_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Hinzufügen-Optionen`)
};

/**
* | output |
* | --- |
* | "More add options" |
*
* @param {Lean_Green_Rat_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_green_rat_gaze = /** @type {((inputs?: Lean_Green_Rat_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Green_Rat_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_green_rat_gaze(inputs)
	return de_lean_green_rat_gaze(inputs)
});